import React, { useEffect, useState } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { useNavigate } from "react-router-dom";
import { getBrandRole, getBrandStore, postBrandUser, postStoreUsersStoreConfig, postSwitchStoreUsersStoreConfig, putBrandUser } from "../../../services/StoreUsers/PostStoreUsers";
import { FloatLabel } from "primereact/floatlabel";
import SuccessModal from "../../SuccessModal";

const SwitchRiderUserModal = ({
  switchRiderUserModalVisible,
  setSwitchRiderUserModalVisible,
  sendDataToUserList,
  brandId,
  selectedRiderInfo,
  selectedStoreValue
}) => {

  const navigate = useNavigate();


  const [assignStoreValue, setAssignStoreValue] = useState("");

  const [storeData, setStoreData] = useState('');


  const [modalVisible, setModalVisible] = useState(false);
  const [modalStatus, setModalStatus] = useState(false);
  const [modalText, setModalText] = useState('');

  const [isSubmitButtonPressed, setIsSubmitButtonPressed] = useState(false);

  const fetchStoreUser = (selectedStoreValue) => {
    getBrandStore(brandId)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          const filterData = Res.filter((item) => item.enabledSwitchStoreUser === true).filter((item) => item.id !== selectedStoreValue);
          const newRes = filterData.map((item) => ({
            name: item.storeName,
            value: item.id,
          }));
          setStoreData(newRes);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };


  useEffect(() => {
    fetchStoreUser(selectedStoreValue);
  }, [selectedStoreValue]);

  const handleAssignStoreChange = (selectedItem) => {
    setAssignStoreValue(selectedItem);
    // fetchStoreRiderInfo(selectedItem);
    // setStoreId(selectedItem);
  };


  const handleDataSubmit = () => {
    const updatedData = {
      store: {
        id: assignStoreValue,
      },
      userId: selectedRiderInfo?.id,
      status: "ACTIVE",
    };



      // Set the state to indicate that the button has been pressed

      if (!isSubmitButtonPressed) {
        setIsSubmitButtonPressed(true);
        postSwitchStoreUsersStoreConfig(brandId, updatedData)
          .then((response) => {
            if (!response.data.error) {
              const Res = response.data;

              if (Res) {
                const message = Res.message;
                const status = Res.status;
                setIsSubmitButtonPressed(false);
               
                if (status === true) {
                  setModalVisible(true);
                  setModalStatus("success");
                  setModalText(message);
                } else {
                  setModalVisible(true);
                  setModalStatus("not Success");
                  setModalText(message);
                }
                sendDataToUserList({
                  success: true,
                });
                setTimeout(() => {
                  setSwitchRiderUserModalVisible(false);
                  setAssignStoreValue("");
                }, 2000);
              }
            }
          })
          .catch((err) => {
            console.error("Error:", err);
          });
      }
  };

  const handleModalClose = () => {
    setIsSubmitButtonPressed(false);
    sendDataToUserList({
      success: true,
    });
    setAssignStoreValue("")
    setSwitchRiderUserModalVisible(false);
  };

  return (
    <div className="flex justify-content-center">
      <Dialog

        visible={switchRiderUserModalVisible}
        style={{ width: "50vw" }}
        onHide={() => {
          if (!switchRiderUserModalVisible) return;
          handleModalClose();
        }}
        content={({ hide }) => (
          <div
            className="flex flex-column gap-2 "
            style={{
              borderRadius: "12px",
              backgroundColor: "#fff",
            }}
          >
            <div
              className="flex border-round-xl  justify-content-between align-items-center gap-2 px-4"
              style={{
                backgroundImage:
                  "radial-gradient(circle at left top, #2B70D7, #1752AA)",
              }}
            >
              <div>
                <img
                  src={"Laundy_App_Icons_Gifs/Home_Page_Menu_Bar/Quick_add_customer.png"}
                />
              </div>
              <p className=" text-4xl text-primary-50 font-semibold uppercase">
                Switch Rider
              </p>
              <Button
                label="x"
                onClick={(e) => hide(e)}
                text
                className=" text-2xl text-primary-50 border-1 "
              ></Button>
            </div>

            <div className="mx-4 flex flex-row justify-content-between">
              <p className="text-md ">Rider Name: <span className="text-lg font-bold">{selectedRiderInfo?.fullName}</span></p>
              <p className="text-md ">Rider Mobile: <span className="text-lg font-bold">{selectedRiderInfo?.mobileNo}</span></p>
            </div>

            <div className="mx-4 my-4">
              <FloatLabel>
                <Dropdown
                  id="assignStoreValue"
                  value={assignStoreValue}
                  onChange={(e) => handleAssignStoreChange(e.target.value)}
                  options={storeData}
                  optionLabel="name"
                  placeholder="Store"
                  className="w-full border-round-xl  text-2xl text-xl shadow-2"
                />
                <label
                  htmlFor="assignStoreValue"
                  className="text-md"
                  style={{ color: "blue" }}
                >
                  Store <span style={{ color: "red" }}>*</span>
                </label>
              </FloatLabel>
            </div>

            {assignStoreValue === "" &&  <div className="mx-4 flex flex-row justify-content-between">
            <p className="text-md" style={{color:'red'}}>* Please select Store</p>
            </div>}

            <Button
              className="mt-1 mb-3 mx-4 border-round-xl "
              onClick={handleDataSubmit}
              disabled={isSubmitButtonPressed || assignStoreValue === ""}
            >
              <p className=" w-full text-2xl font-semibold flex justify-content-center">
                Switch Rider
              </p>
            </Button>

          </div>

        )}
      ></Dialog>

      <SuccessModal
              setModalVisible={setModalVisible}
              modalVisible={modalVisible}
              status={modalStatus}
              text={modalText}
            />
    </div>
  );
};

export default SwitchRiderUserModal;
